import { WarningIcon } from '../../assets/icons';
import useSubgraphHealth from '../../hooks/analytics/useSubgraphHealth';
import { useEffect } from 'react';
import useToastState from '../../context/toast/useToastState';

const NetworkIndicator = () => {
    const { isHealthy, isLoading } = useSubgraphHealth();

    const { setToast } = useToastState();

    useEffect(() => {
        if (!isLoading && !isHealthy) {
            setToast(
                {
                    type: 'secondary',
                    message: (
                        <>
                            <div className='icon-container'>
                                <WarningIcon />
                            </div>
                            <span>3rd-Party network latency detected</span>
                        </>
                    ),
                },
                'network-indicator'
            );
        }
    }, [isHealthy, isLoading, setToast]);

    return null;
};

export default NetworkIndicator;
